import React, { useContext } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { AppContext } from "../AppProvider/AppProvider";

const Nav = styled.div`
  position: absolute;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  width: 100%;
  z-index: 999;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  background-color: var(--min-color);
`;

const NavBtn = styled.div`
  cursor: pointer;
  user-select: none;

  span {
    background-color: var(--sec-color);
    border-radius: 20px;
    display: block;
    width: 30px;
    height: 3px;
    transition-duration: 250ms;
    transition-timing-function: cubic-bezier(0.13, 0.24, 0.25, 1.64);
    user-select: none;

    &.one,
    &.two {
      margin-bottom: 5px;
    }
    &.one {
      width: 25px;
    }
    &.three {
      width: 17px;
    }
  }

  &.active {
    span {
      width: 30px;
    }
    .one {
      box-shadow: 0 2px 3px rgba(0, 0, 0, 0.4);
      transform: translate(-3px, 9px) rotate(45deg);
    }
    .two {
      background-color: transparent;
      transform: translateX(-30px);
    }
    .three {
      box-shadow: 0 2px 3px rgba(0, 0, 0, 0.4);
      transform: translate(-3px, -8px) rotate(-45deg);
    }
  }
`;

const Line = styled.span``;

const Brand = styled(Link)`
  color: var(--sec-color);
`;

const Navbar = ({ brand }) => {
  const [isOpen, setIsOpen] = useContext(AppContext);

  let classActive;

  if (isOpen) {
    classActive = "active";
  }

  return (
    <Nav>
      <NavBtn className={classActive} onClick={() => setIsOpen(!isOpen)}>
        <Line className="one" />
        <Line className="two" />
        <Line className="three" />
      </NavBtn>
      <Brand>{brand}</Brand>
    </Nav>
  );
};

export default Navbar;
